import * as stylex from "@stylexjs/stylex";
import type { AccountUser } from "./account-records";
import { styles } from "./account-avatar.styles";

export function PersonCircle({
  user,
  paired = false,
}: {
  readonly user: AccountUser | null;
  readonly paired?: boolean;
}) {
  const initial =
    (user?.name ?? user?.email ?? "").trim().charAt(0).toUpperCase() || "?";
  return (
    <span
      {...stylex.props(
        styles.circle,
        paired && styles.person,
        paired && !user?.image && styles.personWithoutPhoto,
      )}
    >
      {user?.image ? (
        <img src={user.image} alt="" {...stylex.props(styles.picture)} />
      ) : user ? (
        <span aria-hidden>{initial}</span>
      ) : null}
    </span>
  );
}
